import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";
import type { ApiResponse } from "./api-client.service";

import type {
  Menu,
  MenuFilter,
  MenuApiResponse,
  MenuPayload,
} from "../types/rbac-menus.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.rbacMenus;

const failure = (error: unknown, fallback: string) => ({
  success: false,
  statusCode: 500,
  message: error instanceof Error ? error.message : fallback,
  resData: null,
});

export const rbacMenusService = {
  async list(filter: MenuFilter): Promise<MenuApiResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<MenuApiResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load rbac-menus list.") as unknown as MenuApiResponse;
    }
  },

  async details(id: number | string): Promise<ApiResponse<Menu>> {
    try {
      return await apiClient<ApiResponse<Menu>>(endpoints.details(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load rbac-menus details.") as unknown as ApiResponse<Menu>;
    }
  },

  async create(payload: MenuPayload): Promise<ApiResponse<Menu>> {
    try {
      return await apiClient<ApiResponse<Menu>>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to create rbac-menus.") as unknown as ApiResponse<Menu>;
    }
  },

  async update(id: number | string, payload: Partial<MenuPayload>): Promise<ApiResponse<Menu>> {
    try {
      return await apiClient<ApiResponse<Menu>>(endpoints.update(id), {
        method: "PATCH",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to update rbac-menus.") as unknown as ApiResponse<Menu>;
    }
  },

  async delete(id: number | string): Promise<ApiResponse<unknown>> {
    try {
      return await apiClient<ApiResponse<unknown>>(endpoints.delete(id), {
        method: "DELETE",
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to delete rbac-menus.") as unknown as ApiResponse<unknown>;
    }
  },
};
